/**
 * Site JS
 */

//import './global';
//import './template-tags';
//import './templates';
//import './blocks';

import 'jquery';

// import Swiper JS
// Cant work out why this wont import, using local bundle for now.
//import Swiper, { Keyboard, Mousewheel, Navigation } from 'swiper';
//Swiper.use( [ Keyboard, Mousewheel, Navigation ] );

import Swiper from './vendor/swiper-bundle';

import ScrollReveal from 'scrollreveal';

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper( '.swiper', {
	// Optional parameters
	loop: true,
	loopedSlides: 2,
	autoHeight: true,
	grabCursor: true,
	keyboard: {
		enabled: true,
	},
	mousewheel: {
		invert: true,
		forceToAxis: true,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
} );

const heroSwiper = new Swiper( '.heroSwiper', {
	// Optional parameters
	loop: true,
	autoHeight: false,
	grabCursor: true,
	keyboard: {
		enabled: true,
	},
	mousewheel: {
		invert: true,
		forceToAxis: true,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
} );

ScrollReveal().reveal( '.sr--fadeup', {
	delay: 500,
	distance: '20px',
	origin: 'bottom',
	duration: 1000,
} );

ScrollReveal().reveal( '.sr--fade', {
	delay: 500,
	distance: '0',
	duration: 500,
} );

jQuery( '.header__hamburger' ).on( 'click', function ( e ) {
	e.preventDefault();

	if ( jQuery( 'body' ).hasClass( 'book-active' ) ) {
		jQuery( 'body' ).removeClass( 'book-active' );
	} else {
		jQuery( 'body' ).toggleClass( 'menu-active' );
	}
} );

jQuery( "a[href='#book'" ).on( 'click', function ( e ) {
	e.preventDefault();
	jQuery( 'body' ).toggleClass( 'book-active' );
	jQuery( 'body' ).removeClass( 'menu-active' );
} );

// Select all links with hashes
jQuery( 'a[href*="#"]' )
	// Remove links that don't actually link to anything
	.not( '[href="#"]' )
	.not( '[href="#0"]' )
	.click( function ( event ) {
		// On-page links
		if (
			location.pathname.replace( /^\//, '' ) ==
				this.pathname.replace( /^\//, '' ) &&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = jQuery( this.hash );
			target = target.length
				? target
				: jQuery( '[name=' + this.hash.slice( 1 ) + ']' );
			// Does a scroll target exist?
			if ( target.length ) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				jQuery( 'html, body' ).animate(
					{
						scrollTop: target.offset().top - 150,
					},
					1000,
					function () {
						// Callback after animation
						// Must change focus!
						var $target = $( target );
						$target.focus();
						if ( $target.is( ':focus' ) ) {
							// Checking if the target was focused
							return false;
						} else {
							$target.attr( 'tabindex', '-1' ); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
					}
				);
			}
		}
	} );
